// extracted by mini-css-extract-plugin
module.exports = {"chartArea":"CreatorsDetailsTile_chartArea__QM1m8"};